import React from "react"
import { Nav, Form, Row, Col, Button } from "react-bootstrap"
import { savePref, fetchAPIData } from "../../api/AuthService"
import { SAVE_PREF, FETCH_PREF } from "../../constant/Constants"
import { mapKeys, checkFilterView } from "./EventHandler"
import WhereUsedModal from "./WhereUsedModal"
class SideNav extends React.Component {
   _isMounted = false
   constructor(props) {
      super(props)
      this.handleClick = this.handleClick.bind(this)
      this.selectedCheckboxes = new Set()
      this.state = {
         toggleSection: "Link",
         disable: true,
         choices: [],
         filters: {},
         loading: false,
         modalShow: false,
      }
      const pathParts = window.location.pathname.split("/")
      this.Path = pathParts[1] === "preliminary" ? pathParts[2] : pathParts[1]
   }

   handleWhereUsed() {
      this.setState({ modalShow: true })
   }
   onCloseModal = () => {
      this.setState({ modalShow: false })
   }

   // handleClick(val) {
   //    window.scrollTo(
   //       0,
   //       document.getElementById(val).parentNode.parentNode.offsetTop + 35
   //    )
   //    focusOnSection(val)
   // }

   handleClick(val) {
      const element = document.getElementById(val)
      if (element) {
         // Scroll to the element directly
         window.scrollTo({
            top: element.offsetTop - 130,
            behavior: 'smooth'
         })

         // Make sure the section is expanded
         // The collapse div's previous sibling should be the Card containing the Card.Body
         const card = element.previousSibling
         if (card && card.querySelector) {
            const icon = card.querySelector('[name="accordItem"]')
            if (icon && icon.className.includes("fa-plus-circle")) {
               // Section is collapsed, expand it
               icon.className = "fa fa-minus-circle accordIconStyle"
               element.style.display = "block"
            }
         }
      } else {
         console.warn(`⚠️ Element with id "${val}" not found in DOM`)
      }
   }
   handleSave = () => {
      var value = ""
      var completeList = "ALL"

      for (const checkbox of this.selectedCheckboxes) {
         value = value + "|" + checkbox
      }
      var totalItems = document.getElementsByName("UserPrefCheckBox")
      var checkedItems = Array.from(this.selectedCheckboxes)
      if (totalItems.length === checkedItems.length) {
         completeList = "ALL"
      } else {
         completeList = value.substring(1, value.length)
      }
      this.setState({ loading: true })
      savePref(SAVE_PREF, this.Path, completeList)
         .then((res) => {
            var list = this.getKeysObj(Array.from(this.selectedCheckboxes))
            var isFilterView = checkFilterView()
            this.props.handler(list, isFilterView)
            this.setState({ toggleSection: "Link" })
            this.setState({ loading: false })
         })
         .catch((error) => {
            console.log(" error", error)
            this.setState({ loading: false })
         })
   }

   toggleCheckbox = (e) => {
      this.selectedCheckboxes.add("whereUsed")

      if (this.selectedCheckboxes.has(e.target.value)) {
         this.selectedCheckboxes.delete(e.target.value)
      } else {
         this.selectedCheckboxes.add(e.target.value)
      }
      this.setState({
         disable: this.selectedCheckboxes.size === 1 ? true : false,
         choices: Array.from(this.selectedCheckboxes),
      })
      if (this.selectedCheckboxes.size > 0) {
         var list = this.getKeysObj(Array.from(this.selectedCheckboxes))

         var isFilterView = checkFilterView()
         this.props.handler(list, isFilterView)
      }
   }



   handleLinkClick = (e) => {
      this.setState({ toggleSection: "Link" })
   }
   handleFileters = (e) => {
      this.setState({ toggleSection: "Filters" })
      for (var i = 0; i < this.state.choices.length; i++) {
         this.selectedCheckboxes.add(this.state.choices[i])
      }
      this.setState({
         disable: (this.selectedCheckboxes.size === 0 || this.selectedCheckboxes.size === 1) ? true : false,
      })
   }

   getButtons() {
      if (this.props.data) {
         return (
            <Row style={{ margin: "3px" }}>
               <Col className="leftSection shadow">
                  <button
                     className={
                        this.state.toggleSection === "Link"
                           ? "activeButton"
                           : "inactiveButton"
                     }
                     onClick={this.handleLinkClick}
                  >
                     Links
                  </button>
               </Col>
               <Col className="leftSection shadow">
                  <button
                     className={
                        this.state.toggleSection === "Filters"
                           ? "activeButton"
                           : "inactiveButton"
                     }
                     onClick={this.handleFileters}
                  >
                     Filters
                  </button>
               </Col>
            </Row>
         )
      }
   }

  getNavLinks() {
   if (this.props.data && Array.isArray(this.props.data)) {
      var keys = []
      for (var k = 0; k < this.props.data.length; k++) {
         try {
            const fullText = this.props.data[k].innerText.trim()
            const sectionText = fullText.replace(/\s*$/, '')
            let nextElement = this.props.data[k].parentNode.nextSibling

            while (nextElement && nextElement.nodeType === 3) {
               nextElement = nextElement.nextSibling
            }
            if (nextElement) {
               let contentDiv = nextElement.querySelector ? nextElement.querySelector('[id][name="collapseItem"]') : null
               if (!contentDiv && nextElement.getAttribute && nextElement.getAttribute('name') === 'collapseItem') {
                  contentDiv = nextElement
               }

               if (contentDiv && contentDiv.id) {
                  keys[k] = contentDiv.id + "|" + sectionText
               }
            }
         } catch (error) {
            console.error(error)
         }
      }
      // Add safety check for keys array
      var elements = keys.filter(k => k && typeof k === 'string').map((value, key) => {
         const parts = value.split("|")
         const id = parts[0]
         const text = parts.slice(1).join("|")
         return (
            <button
               key={key}
               className="sideNavButton"
               onClick={() => {
                  text.includes("Where Used") ?
                  this.handleWhereUsed() : this.handleClick(id)
               }}
               title={text}
            >
               <i className="fa fa-angle-right"></i> &nbsp;
               {text.length > 25 ? text.substring(0, 23) + "..." : text}
            </button>
         )
      })
      return elements
   }
   return null
}

getCheckBoxes() {
   if (this.state.filters && typeof this.state.filters === 'object') {
      var items = this.state.filters
      var itemKeys = Object.keys(items)
      // Add safety check
      if (!Array.isArray(itemKeys)) {
         console.error('❌ Object.keys did not return an array:', itemKeys)
         return null
      }
      var elements = itemKeys.map((value, key) => {
         return (
            <Form.Group controlId={100 + key} key={100 + key} className="formGroup">
               <Form.Check
                  type="checkbox"
                  label={
                     items[value].length > 25
                        ? items[value].substring(0, 25) + "..."
                        : items[value]
                  }
                  value={value}
                  name="UserPrefCheckBox"
                  className="checkboxStyle"
                  onChange={this.toggleCheckbox}
                  key={100 + key}
                  checked={items[value] == "Where Used" ? true : (this.state.choices.includes(value) ? true : false)}
                  disabled={items[value] == "Where Used" ? true : false}
                  title={items[value]}
               />
            </Form.Group>
         )
      })
      return elements
   }
   return null
}

   selectAll = () => {
      this.selectedCheckboxes.clear()
      var items = document.getElementsByName("UserPrefCheckBox")
      for (var i = 0; i < items.length; i++) {
         if (items[i].type === "checkbox") {
            items[i].checked = true
            this.selectedCheckboxes.add(items[i].value)
         }
      }
      var list = this.getKeysObj(Array.from(this.selectedCheckboxes))
      var isFilterView = checkFilterView()
      this.props.handler(list, isFilterView)
      this.setState({
         disable: false,
         choices: Array.from(this.selectedCheckboxes),
      })
   }
   UnSelectAll = () => {
      var items = document.getElementsByName("UserPrefCheckBox")
      for (var i = 0; i < items.length; i++) {
         if (items[i].type === "checkbox") items[i].checked = false
      }
      this.selectedCheckboxes.clear()
      this.selectedCheckboxes.add("whereUsed")
      this.setState({
         disable: true,
         choices: Array.from(this.selectedCheckboxes),
      })
   }

   getKeysObj = (obj) => {
      var list = {}
      for (var i = 0; i < obj.length; i++) {
         list[obj[i]] = this.state.filters[obj[i]]
      }
      return list
   }

   getChoicesData = async () => {
      var handleToUpdate = this.props.handler
      var Link = localStorage.getItem("UserId") + "/objectName/" + this.Path
      var items = mapKeys(this.props.resData, this.props.Keys)
      var isFilterView = false

      this.setState({ filters: items })

      try {
         const userRes = await fetchAPIData(`${FETCH_PREF}/${Link}`)


         if (userRes && !userRes.data.includes("Not Found")) {
            if (userRes.data === "ALL") {

               if (this._isMounted) {
                  handleToUpdate(items, isFilterView)
                  this.setState({
                     toggleSection: "Link",
                     choices: Object.keys(items),
                  })
               }
            } else {
               var selectedItem = userRes.data.split("|")


               var itemKeys = Object.keys(items)
               var common = selectedItem.filter((x) => itemKeys.indexOf(x) !== -1)



               if (common.length > 0) {
                  var list = this.getKeysObj(common)
                  if (items && selectedItem) {
                     if (itemKeys.length !== selectedItem.length) {
                        isFilterView = true
                     }
                  }
                  handleToUpdate(list, isFilterView)
               } else {
                  handleToUpdate(items, isFilterView)
               }
               if (this._isMounted) {
                  this.setState({
                     toggleSection: "Link",
                     choices: common,
                  })
               }
            }
         } else {

            if (this._isMounted) {
               handleToUpdate(items, isFilterView)
               this.setState({
                  toggleSection: "Link",
               })
            }
         }
      } catch (error) {
        
         handleToUpdate(this.props.Keys, isFilterView)
         this.setState({
            toggleSection: "Link",
         })
      }
   }

   componentDidUpdate(prevProps, prevState) {


      if (this.props.resData !== prevProps.resData) {

         this._isMounted = true
         this.getChoicesData()
      }

      if (this.props.data !== prevProps.data) {

         if (this.props.data) {

            this.forceUpdate()
         }
      }

      if (prevState.toggleSection === "Filters" && this.state.toggleSection === "Link") {

         this.forceUpdate()
      }
   }

   componentDidMount() {

      if (this.props.handler) {
         this._isMounted = true
         this.getChoicesData()
      }
   }

   componentWillUnmount() {

      this._isMounted = false
   }

   render() {


      return (
         <React.Fragment>
            <div style={{ margin: "2px" }}>
               {this.getButtons()}
               {this.state.toggleSection === "Link" ? (
                  <>
                     <Nav
                        className="flex-column"
                        style={{ marginTop: "10px" }}
                     >
                        {this.getNavLinks()}
                     </Nav>
                  </>
               ) : (
                  <Nav
                     className="flex-column"
                     style={{ marginTop: "10px", marginBottom: "20px" }}
                  >
                     {this.getCheckBoxes()}
                     <Row style={{ margin: "3px", marginTop: "5px" }}>
                        <Col className="leftSection" align="center">
                           <Button className="activeButton" onClick={this.selectAll}>
                              Select&nbsp;All
                           </Button>
                        </Col>

                        <Col
                           style={{ marginLeft: "3px" }}
                           className="leftSection"
                           align="center"
                        >
                           <Button className="activeButton" onClick={this.UnSelectAll}>
                              Unselect&nbsp;All
                           </Button>
                        </Col>
                     </Row>
                     <Row style={{ marginTop: "5px" }}>
                        <Col className="btnContainer" align="center">
                           <Button
                              style={{ width: "90px", textAlign: "center" }}
                              className="expandCollapseButton"
                              onClick={this.handleSave}
                              disabled={this.state.disable}
                           >
                              {this.state.loading ? (
                                 <i
                                    className="fa fa-spinner fa-spin"
                                    style={{ marginRight: "5px" }}
                                 />
                              ) : (
                                 "Save"
                              )}
                           </Button>
                        </Col>
                     </Row>
                  </Nav>
               )}
            </div>
            <WhereUsedModal
               show={this.state.modalShow}
               onHide={this.onCloseModal}
               name={this.props.Name}
               objectid={this.props.searchData}
               Rev={this.props.Revision}
            />
         </React.Fragment>
      )
   }
}
export default SideNav